import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import Select from '../../../../components/Inputs/Select'
import DateInput from '../../../../components/Inputs/DateInput'
import TextInput from '../../../../components/Inputs/TextInput'
import Button from '../../../../components/Buttons/Button'
import useTranslate from '../../../../hooks/useTranslate'
import FilterReset from '../../../../components/Icons/FilterReset'

const FormWrapper = styled.div`
  margin: 23px 10px 0px 10px;
  box-sizing: border-box;
`

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  row-gap: 20px;
  justify-content: space-between;

  @media (max-width: 1500px) {
    flex-direction: column;
    margin: 30px 0px 10px 0px;
  }
`

const RowWrapper = styled.div`
  display: flex;
  gap: 10px;
`

const SearchWrapper = styled.div`
  width: ${props => props.$isMobile ? '100%' : '300px'};
`

const ActionWrapper = styled.div`
  width: ${props => props.width}px;
`

export default function ListFilter(props) {
  const { filterQuery, setFilterQuery, pageName } = props
  const dispatch = useDispatch()
  const translate = useTranslate()
  const [updatedFilterQuery, setUpdatedFilterQuery] = useState(filterQuery)

  const filterQueryHandler = useCallback(
    (e) => {
      setFilterQuery((prevFilterQuery) => {
        const newFilterQuery = {
          ...prevFilterQuery,
          [e.target.name]: e.target.value,
        }
        dispatch({ type: 'SET_FILTER_QUERY', page: pageName, payload: newFilterQuery })
        setUpdatedFilterQuery(newFilterQuery)

        return newFilterQuery
      })
    },
    [setFilterQuery, dispatch, pageName]
  )

  const paymentStatusSelectOptions = [
    {
      value: '',
      label: '-',
      defaultValue: true,
    },
    { value: 'Завис', label: 'Завис' },
    { value: 'Оплачен', label: 'Оплачен' },
    { value: 'Не оплачен', label: 'Не оплачен' },
  ]

  const paymentTypeSelectOptions = [
    {
      value: '',
      label: '-',
      defaultValue: true,
    },
    { value: 'Ндс', label: 'Ндс' },
    { value: 'Нал', label: 'Нал' },
    { value: 'Без ндс', label: 'Без ндс' },
  ]

  const transportCategorySelectOptions = [
    {
      value: '',
      label: '-',
      defaultValue: true,
    },
    { value: 'own', label: 'Свой' },
    { value: 'hired', label: 'Наемный' },
  ]

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const statusSelectOptions = [
    {
      value: '',
      label: '-',
      defaultValue: true,
    },
    { value: 'active', label: 'Активный' },
    { value: 'markedForDeletion', label: 'На удаление' },
  ]

  const overdueDebtSelectOptions = [
    {
      value: '',
      label: '-',
      defaultValue: false,
    },
    { value: true, label: 'Просрочено' },
  ]

  return (
    <FormWrapper>
      <Form>
        {/* ------- SEARCH ------- */}
        <RowWrapper>
          <SearchWrapper $isMobile={windowWidth <= 1500}>
            <TextInput
              label='Поиск...'
              id='search'
              name='search'
              value={updatedFilterQuery.search}
              borderOption={3}
              debounceDelay={500}
              forceDarkMode={true}
              isClearable={true}
              disabled={false}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </SearchWrapper>
        </RowWrapper>
        {/* ------- STATUS ------- */}
        <RowWrapper>
          <ActionWrapper width={150}>
            < Select
              label={'Статус'}
              id='status'
              name='status'
              value={updatedFilterQuery.status}
              options={statusSelectOptions}
              forceDarkMode={true}
              searchable={false}
              disabled={false}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </ActionWrapper>
          <ActionWrapper width={150}>
            < Select
              label={'Срок оплаты'}
              id='overdueDebt'
              name='overdueDebt'
              value={updatedFilterQuery.overdueDebt}
              options={overdueDebtSelectOptions}
              forceDarkMode={true}
              searchable={false}
              disabled={false}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </ActionWrapper>
        </RowWrapper>
        <RowWrapper>
          {/* ------- PAYMENT TYPE ------- */}
          <ActionWrapper width={150}>
            < Select
              label={'Форма оплаты'}
              id='paymentType'
              name='paymentType'
              value={updatedFilterQuery.paymentType}
              options={paymentTypeSelectOptions}
              forceDarkMode={true}
              searchable={false}
              disabled={false}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </ActionWrapper>
          {/* ------- PAYMENT STATUS ------- */}
          <ActionWrapper width={150}>
            < Select
              label={'Статус оплаты'}
              id='paymentStatus'
              name='paymentStatus'
              value={updatedFilterQuery.paymentStatus}
              options={paymentStatusSelectOptions}
              forceDarkMode={true}
              searchable={false}
              disabled={false}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </ActionWrapper>
        </RowWrapper>
        <RowWrapper>
          {/* ------- TRANSPORT CATEGORY ------- */}
          <ActionWrapper width={150}>
            <Select
              label={'Категория транспорта'} // На русском
              id='transportCategory'
              name='transportCategory'
              value={updatedFilterQuery.transportCategory}
              options={transportCategorySelectOptions}
              forceDarkMode={true}
              searchable={false}
              disabled={false}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </ActionWrapper>
        </RowWrapper>
        <RowWrapper>
          {/* ------- START DATE ------- */}
          <ActionWrapper width={150}>
            <DateInput
              label={'От:'}
              name={'startDate'}
              id={'startDate'}
              forceDarkMode={true}
              disabled={false}
              debounceDelay={1000}
              value={updatedFilterQuery.startDate}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </ActionWrapper>
          {/* ------- END DATE ------- */}
          <ActionWrapper width={150}>
            <DateInput
              label={'До:'}
              name={'endDate'}
              id={'endDate'}
              forceDarkMode={true}
              disabled={false}
              debounceDelay={1000}
              value={updatedFilterQuery.endDate}
              onChange={(e) => {
                filterQueryHandler(e)
              }}
            />
          </ActionWrapper>
        </RowWrapper>
        <RowWrapper>
          {/* ------- CLEAR BUTTON ------- */}
          <Button
            title={translate('resetFilter')}
            style={{ width: windowWidth <= 1500 ? '100%' : '44px', backgroundColor: 'var(--alert-button-bg)', padding: '8px' }}
            value=''
            disabled={Object.values(updatedFilterQuery).every(value => value === '' || !value)}
            onClick={(e) => {
              e.preventDefault()
              const reset = {
                search: '',
                status: '',
                overdueDebt: false,
                paymentStatus: '',
                paymentType: '',
                transportCategory: '',
                startDate: '',
                endDate: '',
              }
              setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                ...reset
              }))
              setUpdatedFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                ...reset
              }))
              dispatch({ type: 'SET_FILTER_QUERY', page: pageName, payload: reset })
            }}
          >
            <FilterReset size={22} color={Object.values(updatedFilterQuery).every(value => value === '') ? 'var(--text-color-disabled)' : '#fff'} />
          </Button>
        </RowWrapper>
      </Form>
    </FormWrapper>
  )
}
